//  学习班类型相关 api
import request from '@/api/request'

// 获取修改页面数据
export function saveApi(data:any){
    let url = '/api/manager/user/save';

    return request({
        url: url,
        method: 'post',
        data
    })
}


// 获取修改页面数据
export function editInitApi(id:string){
    let url = '/api/manager/user/edit/init';
    let data = {
        "id":id
    }
    return request({
        url: url,
        method: 'post',
        data
    })
}

export function editInitGenderApi(id:string){
    let url = '/api/manager/user/edit/init/gender';
    let data = {
        id
    }
    return request({
        url: url,
        method: 'post',
        data
    })
}

// 更新修改页面
export function editSaveApi(data:any){
    let url = '/api/manager/user/edit/save';
    return request({
        url: url,
        method: 'post',
        data
    })
}

export function editSaveGenderApi(data:any){
    let url = '/api/manager/user/edit/save/gender';
    return request({
        url: url,
        method: 'post',
        data
    })
}

// 搜索
export function optionsApi(query:string){
    let data = {
        "query": query
    }

    let url = '/api/manager/user/options';
    return request({
        url: url,
        method: 'post',
        data
    })
}

export function optionsOwnApi(query:string){
    let data = {
        "query": query
    }

    let url = '/api/manager/user/options/own';
    return request({
        url: url,
        method: 'post',
        data
    })
}

// 根据排课信息获取用户信息
export function getfromschedulingApi(sid:string){
    let data = {
        "sid": sid
    }

    let url = '/api/manager/user/getfromscheduling';
    return request({
        url: url,
        method: 'post',
        data
    })
}



// 获取学习班类型列表
// export function optionsApi(data:any){
//     let url = '/api/manager/studyclasstype/options';
//     return request({
//         url: url,
//         method: 'post',
//         data
//     })
// }

// 根据单位 id 搜索学员
export function getCompanyPeopleApi(data:any) {
    let url = '/api/manager/user/options/classunit';
    return request({
        url: url,
        method: 'post',
        data
    })
}

// 根据组织 id 搜索学员
export function getOrganPeopleApi(data:any) {
    let url = '/api/manager/user/options/partyorg';
    return request({
        url: url,
        method: 'post',
        data
    })
}